export default [
    {
        name: "患者人口学信息",
        children: [
            {
                name: "人口学信息"
            }
        ]
    },
    {
        name: "主诉",
        children: [
            {
                name: "主诉信息"
            }
        ]
    },
    {
        name: "既往病史",
        children: [
            {
                name: "既往病史"
            }
        ]
    },
    {
        name: "月经婚育史",
        children: [
            {
                name: "月经史"
            },
            {
                name: "婚育史"
            }
        ]
    },
    {
        name: "家族史",
        children: [
            {
                name: "家族疾病"
            }
        ]
    },
    {
        name: "现病史",
        children: [
            {
                name: "现病史"
            }
        ]
    },
    {
        name: "体格检查",
        children: [
            {
                name: "体格检查"
            }
        ]
    },
    {
        name: "中医四诊",
        children: [
            {
                name: "五脏功能"
            },
            {
                name: "脏腑部位"
            },
            {
                name: "形体表现"
            },
            {
                name: "官窍部位"
            },
        ]
    },
    {
        name: "实验室检验",
        children: [
            {
                name: "血常规"
            },
            {
                name: "尿常规"
            },
            {
                name: "其它检验"
            }
        ]
    },
    {
        name: "诊断",
        children: [
            {
                name: "中医诊断"
            },
            {
                name: "西医疾病"
            }
        ]
    },
    {
        name: "处方用药",
        children: [
            {
                name: "中药饮片信息"
            },
            {
                name: "其它用药信息"
            }
        ]
    },
    {
        name: "疗效评价",
        children: [
            {
                name: "疗效反馈"
            }
        ]
    }
];
